import { EMetricKey } from '~/types/metric';

export const hasMetricData = (metric?: Record<string, unknown>): boolean => {
  const sessions = metric?.[EMetricKey.SESSION];
  return typeof sessions === 'number' && sessions > 0;
};
